import { render, staticRenderFns } from "./TableReportKpis.vue?vue&type=template&id=151b16ae"
import script from "./TableReportKpis.vue?vue&type=script&lang=js"
export * from "./TableReportKpis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports